import { EpicIcons, Icon, Tooltip, TooltipPosition } from "@constellation-academy/epic-ui";
import { knownGapIconClass, knownGapTextClass } from "./known-gap-info.styles";
import { type KnownGapInfoProps } from "./known-gap-info.types";

export const KnownGapInfo = ({ id, text }: KnownGapInfoProps) => (
	<>
		<Tooltip target={`#${id}`} position={TooltipPosition.Top}>
			<div className={knownGapTextClass}>{text}</div>
		</Tooltip>
		<span id={id} className={knownGapIconClass} tabIndex={0} role="img" aria-label={text}>
			<Icon icon={EpicIcons.INFO_CIRCLE} />
		</span>
	</>
);
